import { useMutation } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { ExportParticipant } from '../mutations/exportParticipant.mutation';
import type { ExportParticipantMutation, ExportParticipantMutationVariables } from '../types';

export const useExportParticipantMutation = (
  options?: MutationOptions<ExportParticipantMutation, ExportParticipantMutationVariables>,
) => {
  return useMutation(gqlFetcher(ExportParticipant), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);
    },
  });
};
